<template>
  <div class="live">    
    <main-content
      :background-image="backgroundImage"
      right-sidebar="true"
    >
      <div class="live__background-heading">{{ language.code === 'en' ? 'Choose your address' : 'اختر عنوانك' }}</div>
      <div class="live__markers">
        <transition-group name="fast-fade">
          <router-link
            v-for="(livingOption, i) in livingOptions"
            :key="livingOption._id"          
            :to="`/live/${livingOption._id}`"
          >
            <tag-reference
              class="live__tag-reference"
              :class="{ 'live__tag-reference--disabled' : livingOption.filter }"
              :pos="{ x: livingOption.marker.x, y: livingOption.marker.y }"
              :label="i + 1"
            />
          </router-link>
        </transition-group>
      </div>
      <transition name="fade-in-up">
        <div v-if="activeLivingOption" class="live__option-info">
          <div class="live__option-info-heading">{{ activeLivingOption.label }}</div>
          <img :src="$store.state.assetsPath + activeLivingOption.logo" />
          <button @click="$router.push(`/live/${activeLivingOption._id}`)"><fa icon="home"/> View Living Options</button>
        </div>
      </transition>
    </main-content>
    <right-sidebar
      :logo="$store.state.config.sidebarLogo"
      :minimap="$store.state.config.liveHereSidebarMinimap"
      :heading="$store.state.property.inputType === null && language.code === 'en' ? 'Masterplan' : $store.state.property.inputType === null && language.code === 'ar' ? 'المخطط الرئيسي' : $store.state.property.inputType + 's'"
      :description="language.code === 'en' ? $store.state.config.liveHereDescription : `
 
يتألف الموج مسقط من أربع مناطق مخططة بشكل متناغم وسط مناظر طبيعية خلابة، وتحيط بها العديد من وسائل المرافق عالمية المستوى.
 
تتمتع كل منطقة بشخصيتها وسماتها الفريدة، حيث تجتمع هذه المناطق معًا لتقديم أسلوب حياة فريد لكل الساكنين في الموج مسقط.
 
      `"
      :navigation-items="navigationItems"
      :enable-slide-out="true"
    > 
      <!-- <div slot="top-slot">
        <property-filter/>
      </div> -->
      <template slot="bottom-slot">
        <button style="opacity: 0;" class="right-sidebar__back"><fa icon="chevron-left"/>{{ language.code === 'en' ? 'Back' : 'عودة' }}</button>
      </template>
      <template slot="slide-out-slot">
        <property-filter/>
      </template>
    </right-sidebar>
  </div>
</template>
<script>
import MainContent from '@/components/MainContent'
import TagReference from '@/components/TagReference'
import PropertyFilter from '@/components/PropertyFilter'
import RightSidebar from '@/components/RightSidebar'
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: 'live',
  components: { MainContent, PropertyFilter, TagReference, RightSidebar },

  data () {
    return {
      activeLivingOption: null
    }
  },

  computed: {
    ...mapGetters({
      language: 'language',
      livingOptionsWithFiltering: 'property/livingOptionsWithFiltering'
    }),

    ...mapState({
      backgroundImage: state => state.config.liveHereBackground,
      properties: state => state.property.properties,
      propertyModels: state => state.property.propertyModels,
    }),

    livingOptions () {
      return _.sortBy(this.$store.getters['property/livingOptionsWithFiltering'], livingOption => {
        return livingOption.marker.x
      })
    },

    navigationItems () {
      let navigationItems = []
      this.livingOptions.forEach((livingOption, i) => {
        navigationItems.push({
          label: `<span class="live__circle">${i + 1}</span> ${livingOption.label[this.language.code]}`,
          to: `/live/${livingOption._id}`,
          key: `${livingOption._id}`,
          disabled: livingOption.filter
        })
      })
      return navigationItems
    }
  },

  created () {
    // this.$store.commit['sidebar/CLOSE_SIDEBAR']
  }, 

  mounted () {
    // if (!this.$store.getters['sidebar/isSlideOutVisible']) {
    //   setTimeout(() => {
    //     this.$store.commit('sidebar/OPEN_SLIDEOUT')
    //   }, 2000)
    // }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";

.live {
  &__tag-reference {
    border: 0.2rem solid $white;
    border-radius: 50%;  
    width: 2.5rem;
    height: 2.5rem;
    transform: translate(-50%, -50%);

    &--disabled {
      opacity: .4;
    }
  }

  &__background-heading {
    font-family: 'Canela';
    font-size: 10rem;
    font-weight: 400;
    color: $white;
    position: absolute;
    top: 5rem;
    left: 5rem;
    letter-spacing: 0.05em;
    line-height: 1;
    padding-top: 2rem;
    text-shadow: 0px 0px 5px rgba($black, 0.5);

    .ar & {
      font-family: 'GE Hili';
    }     

    &:before {
      content: '';
      width: 20rem;
      height: 1.5rem;
      background-color: $lblue;
      position: absolute;
      top: 0;
      left: 0.7rem;
    }    
  }

  &__circle {
    background: #000;
    border: 0.2rem solid $white;
    display: inline-flex;
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
    align-items: center;
    justify-content: center;
    margin-right: 0.5em;
    margin-top: -0.7rem;
    font-weight: 900;
  }  
  
  &__background {
    height: 100rem;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 0;
    width: 152rem;
  }

  &__markers {
    height: 98rem;
    left: 0;
    position: absolute;
    top: 0;
    width: 152rem;
  }

  &__option-info {
    background: rgba($black, 0.5);
    padding: 1rem;
    position: absolute;
    top: 20rem;
    left: 80rem;
    text-align: center;

    img {
      display: block;
      max-width: 100px;
      margin: 1rem auto;
    }

    &-heading {
      font-size: 3rem;
      text-align: center;
    }
  }
}
</style>
